export default __webpack_public_path__ + "static/media/ab03.b3586a30.jpg";